import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0d08dd41&scoped=true&"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=0d08dd41&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d08dd41",
  null
  
)

export default component.exports